/* The type of login */
export enum LoginType {
    GOOGLE = "google",
    FACEBOOK = "facebook",
    PASSWORD = "password",
    ANONYMOUS = "anonymous",
}